import { useEffect, useState } from 'react';

interface ILoadingBarPresenterParams {
  loading: boolean;
}

interface ILoadingBarPresenter {
  clear(): void;
  startProgress(): void;
  stopProgress(): void;
  progress: number;
  isShow: boolean;
}

interface ILoadingBarPresenter {
  progress: number;
}

export function useLoadingBarPresenter({
  loading,
}: ILoadingBarPresenterParams): ILoadingBarPresenter {
  const [progress, setProgress] = useState<number>(0);
  const [isShow, setShow] = useState(false);
  const [intervalId, setIntervalId] = useState<ReturnType<typeof setInterval>>();

  const presenter: ILoadingBarPresenter = {
    progress,
    isShow,

    clear(): void {
      if (intervalId) {
        clearInterval(intervalId);
        setIntervalId(undefined);
      }
    },

    startProgress(): void {
      setShow(true);
      const intervalId = setInterval(() => {
        setProgress((prevProgress) => {
          return prevProgress + (100 - prevProgress) / 8;
        });
      }, 100);

      setIntervalId(intervalId);
    },

    stopProgress(): void {
      presenter.clear();
      if (isShow) {
        setProgress(100);
        setTimeout(() => {
          setShow(false);
          setProgress(0);
        }, 300);
      }
    },
  };

  useEffect(() => {
    if (loading) {
      presenter.startProgress();
    } else {
      presenter.stopProgress();
    }
  }, [loading]);

  useEffect(() => {
    return () => presenter.clear();
  }, []);

  return presenter;
}
